import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Sort"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-sort',
    templateUrl: './icon-sort.component.html',
    styleUrls: ['./icon-sort.component.scss'],
    standalone: false
})
export class IconSortComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
